var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-836.000000, -3670.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(120.000000, 2360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 1281.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(717.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.9462262,19.9731131 C39.9462262,31.0042635 31.0042635,39.9462262 19.9731131,39.9462262 C8.94196274,39.9462262 0,31.0042635 0,19.9731131 C0,8.94196274 8.94196274,0 19.9731131,0 C31.0042635,0 39.9462262,8.94196274 39.9462262,19.9731131",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9731131,20 C39.9731131,31.0311504 31.0311504,39.9731131 20,39.9731131 C8.96884963,39.9731131 0.026886883,31.0311504 0.026886883,20 C0.026886883,8.96884963 8.96884963,0.026886883 20,0.026886883 C31.0311504,0.026886883 39.9731131,8.96884963 39.9731131,20 Z",
    stroke: "#0061ED",
    strokeWidth: 0.998655656
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,0.026886883 C31.0311504,0.026886883 39.9731131,8.96884963 39.9731131,20",
    stroke: "#EBECF0",
    strokeWidth: 0.998655656
  })), /*#__PURE__*/React.createElement("polyline", {
    stroke: "#141B27",
    strokeWidth: 1.2,
    points: "28.8571429 14 16.9123639 26 12.6124124 21.6801697 11 19.939697"
  })))))))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default ForwardRef;